import { useQuery } from '@tanstack/react-query';
import masterServicesAPI from '../../apis/master-services';
import { Condition } from '../Questionnaires/QuestionnairesList/components/types';

export const useCondition = (conditionId?: string) => {
  const { data: condition, isLoading, refetch } = useQuery({
    queryKey: ['condition', conditionId],
    queryFn: () => {
      if (!conditionId) return Promise.resolve(null);

      return masterServicesAPI.getServiceCondition(conditionId) as Promise<Condition>;
    }
  });

  return { condition, isLoading, refetch };
};
